import type { UniversalModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import { useOverridableInput } from "@editor/components/common/designSystem/hooks/useOverridableInput";
import Input from "@editor/components/common/designSystem/Input";

import { useSeletedElementDesignations } from "@/features/react-editor/components/modifiers/store/ModifiersStoreContext";
import { useOverridableState } from "replo-runtime/shared/hooks/useOverridableState";

interface LinkModifierProps {
  onChange: (modifiers: UniversalModifierValue[]) => void;
}

const LinkModifier: React.FC<LinkModifierProps> = ({ onChange }) => {
  const selectedElementDesignations = useSeletedElementDesignations();
  const linkDesignation = selectedElementDesignations?.find(
    (designation) => designation.type === "link",
  );

  // Get current href from the link designation
  const currentHref = linkDesignation?.href ?? "";

  // Use overridable state for the href value
  const [hrefValue, setHrefValue] = useOverridableState(currentHref);

  // Use overridable input for debounced changes
  const inputProps = useOverridableInput({
    value: hrefValue,
    onValueChange: (newHref: string) => {
      setHrefValue(newHref);
      onChange([
        {
          type: "href",
          value: newHref,
        },
      ]);
    },
  });

  if (!linkDesignation) {
    return null;
  }

  return (
    <Input
      placeholder="Enter URL (e.g., https://example.com)"
      {...inputProps}
    />
  );
};

export default LinkModifier;
